import { SAVE_EXACT_ORDERS } from "../constants/Exact";

const initState = {
  orders: [],
  fetchedAt: null,
  query: null,
};

const exact = (state = initState, action) => {
  switch (action.type) {
    case SAVE_EXACT_ORDERS:
      return {
        ...state,
        orders: action.payload.orders,
        fetchedAt: action.payload.fetchedAt,
        query: action.payload.query,
      };
    default:
      return state;
  }
};

export default exact;
